import "@Styles/mandate.css";
import moment from "moment";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import OtpInput from "react-otp-input";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form } from "semantic-ui-react";
import "react-toastify/dist/ReactToastify.css";
import ToastMsg from "@Helper/ToastMsg";
import arrowleft from "@Images/NewUI/Vector.png";
import {
  applyForLoan,
  eSignWebView,
  getPromoList,
  rewardPoint,
  notifyVisitorEvent,
} from "@Redux/ApplyLoan/action";
import { sentOtpForappyLoan } from "@Redux/Authenticate/action";
import { getDocumentStatus } from "../../../Redux/Manual_Kyc_Details/action";
import { HEADING_LOANDETAIL } from "../Common/constant";

const NAME_REGEX = /^[A-Za-z\s'-]*$/;
const PHONE_VALID_STARTS = ["6", "7", "8", "9"];

const handleAuthError = (err) => {
  if (err?.response?.status === 401) {
    localStorage.removeItem("gpay_token");
    window.location.href = "/";
    return true;
  }
  return false;
};

const buildLoanData = (state, includeReferences = false) => {
  const { voucher, rewardPointValue, paymeCoins, reference_1_name, reference_2_name, reference_1_phone, reference_2_phone } = state;
  
  const baseData = {
    amount: localStorage.getItem("loanAmount"),
    applied_for_insurance: false,
    applied_for_medibuddy: false,
    coupon_code: voucher || null,
    loan_type: localStorage.getItem("loan_type"),
    mars_applied_for_insurance: false,
    medibuddy_package: 0,
    nominee_name: null,
    nominee_relationship: "",
    paymee_coins: paymeCoins && rewardPointValue ? rewardPointValue : null,
    reason_for_loan: localStorage.getItem("loanReason"),
    repayment_date: moment(localStorage.getItem("repayDate")).format("YYYY-MM-DD"),
  };

  if (includeReferences) {
    return {
      ...baseData,
      reference_1_name: reference_1_name || null,
      reference_1_phone: reference_1_phone || null,
      reference_2_name: reference_2_name || null,
      reference_2_phone: reference_2_phone || null,
    };
  }

  return baseData;
};

const LoanDetails = (props) => {
  const navigate = useNavigate();
  const token = props?.user?.User?.token || localStorage.getItem("gpay_token");
  const userPhone = props?.userDetail?.user_detail?.customusermodel?.phone_number;

  const [esignVerified, setEsignVerified] = useState("");
  const [show] = useState(false);
  const [voucher, setVoucher] = useState("");
  const [rewardPointValue, setRewardPointValue] = useState("");
  const [paymeCoins, setPaymeCoins] = useState(false);
  const [, setPaymeCoinsInRs] = useState("");
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [canResendOtp, setCanResendOtp] = useState(false);
  const [otp, setOtp] = useState("");
  const [references, setReferences] = useState(false);
  const [reference1Name, setReference1Name] = useState("");
  const [reference1Phone, setReference1Phone] = useState("");
  const [reference2Name, setReference2Name] = useState("");
  const [reference2Phone, setReference2Phone] = useState("");
  const [loanState, setLoanState] = useState(false);
  const [someState, setSomeState] = useState(false);
  const [someCheckStatus, setSomeCheckStatus] = useState(false);
  const [consent, setConsent] = useState(false);
  const [isInsurance, setIsInsurance] = useState(false);
  const [showInsurance, setShowInsurance] = useState(null);
  const [, setLoader] = useState(false);

  const timerRef = useRef(null);
  const otpTimerRef = useRef(null);
  const esignVerifiedRef = useRef(esignVerified);
  const loanStateRef = useRef(loanState);
  const someCheckStatusRef = useRef(someCheckStatus);
  const someStateRef = useRef(someState);
  const handleOtpVerifyRef = useRef(null);
  const referencesRef = useRef(references);

  useEffect(() => {
    esignVerifiedRef.current = esignVerified;
    loanStateRef.current = loanState;
    someCheckStatusRef.current = someCheckStatus;
    someStateRef.current = someState;
    referencesRef.current = references;
  }, [esignVerified, loanState, someCheckStatus, someState, references]);

  const fetchInitialData = useCallback(async () => {
    localStorage.setItem("ratingpopupvisible", true);

    try {
      const paymee_coin_in_1_rs = props.userDetail?.user_detail?.paymee_coin_in_1_rs;
      
      const rewardRes = await props.rewardPoint(token);
      if (rewardRes?.reward_point) {
        setRewardPointValue(rewardRes.reward_point);
        if (paymee_coin_in_1_rs) {
          setPaymeCoinsInRs(Math.round(rewardRes.reward_point / paymee_coin_in_1_rs));
        }
      }
    } catch (err) {
      if (!handleAuthError(err)) {
        ToastMsg(err?.response?.data?.error, "error");
      }
    }

    try {
      const promoRes = await props.getPromoList(token);
      setPaymeCoins(false);
      setReferences(promoRes?.reference || false);
      setShowInsurance(promoRes?.insurance || null);
    } catch (err) {
      if (!handleAuthError(err)) {
        ToastMsg(err?.response?.data?.error, "error");
      }
    }

    try {
      const docRes = await props.getDocumentStatus(token);
      const esign = docRes?.data?.esign_verified;
      setEsignVerified(esign || "");
      if (esign) {
        localStorage.setItem("esign_verified", esign);
      }
      if (esign === "S") {
        setLoader(true);
      }
    } catch (err) {
      // Silent fail for document status
    }
  }, [token, props]);

  const pollDocumentStatus = useCallback(async () => {
    try {
      const res = await props.getDocumentStatus(token);
      const esign = res?.data?.[0]?.esign_verified || res?.data?.esign_verified;
      if (esign) {
        setEsignVerified(esign);
        localStorage.setItem("esign_verified", esign);
      }
    } catch (err) {
      // Silent fail
    }
  }, [token, props]);

  useEffect(() => {
    fetchInitialData();

    timerRef.current = setInterval(() => {
      pollDocumentStatus();
      if (esignVerifiedRef.current === "S" && !loanStateRef.current) {
        handleOtpVerifyRef.current?.();
      }
    }, 3000);

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
      if (otpTimerRef.current) clearInterval(otpTimerRef.current);
    };
  }, []);

  const handlePhoneChange = useCallback((value, setter) => {
    const regexMob = /^[0-9\b]+$/;
    if (value === "" || regexMob.test(value)) {
      if (PHONE_VALID_STARTS.includes(value[0]) || value === "" || value.length > 1) {
        const cleanValue = value[0] === "0" ? value.slice(1, 11) : value.slice(0, 10);
        setter(cleanValue);
      }
    }
  }, []);

  const handleNameChange = useCallback((value, setter) => {
    let cleanValue = value.replace(/^\s+/, "").replace(/\s{2,}/g, " ");
    if (NAME_REGEX.test(cleanValue) || cleanValue === "") {
      setter(cleanValue);
    }
  }, []);

  const validateReferences = useCallback(() => {
    const errors = [];
    const ref1Name = reference1Name.trim();
    const ref2Name = reference2Name.trim();

    if (!ref1Name || ref1Name.length <= 1) {
      errors.push("Reference 1 Name is required (minimum 2 characters)");
    }
    if (!reference1Phone || reference1Phone.length !== 10) {
      errors.push("Reference 1 Mobile Number is required (10 digits)");
    }
    if (!ref2Name || ref2Name.length <= 1) {
      errors.push("Reference 2 Name is required (minimum 2 characters)");
    }
    if (!reference2Phone || reference2Phone.length !== 10) {
      errors.push("Reference 2 Mobile Number is required (10 digits)");
    }
    if (reference1Phone && reference2Phone && reference1Phone === reference2Phone) {
      errors.push("Reference1 and Reference2 should not be same");
    }
    if (reference1Phone && reference1Phone === userPhone) {
      errors.push("Reference1 mobile no should not be same as login user mobile no.");
    }
    if (reference2Phone && reference2Phone === userPhone) {
      errors.push("Reference2 mobile no should not be same as login user mobile no.");
    }

    return errors;
  }, [reference1Name, reference1Phone, reference2Name, reference2Phone, userPhone]);

  const startOtpTimer = useCallback(() => {
    setMinutes(1);
    setSeconds(0);
    setCanResendOtp(false);

    if (otpTimerRef.current) clearInterval(otpTimerRef.current);

    otpTimerRef.current = setInterval(() => {
      setSeconds((prevSeconds) => {
        if (prevSeconds > 0) return prevSeconds - 1;
        
        setMinutes((prevMinutes) => {
          if (prevMinutes === 0) {
            clearInterval(otpTimerRef.current);
            setCanResendOtp(true);
            return 0;
          }
          return prevMinutes - 1;
        });
        
        return prevSeconds === 0 ? 59 : prevSeconds - 1;
      });
    }, 1000);
  }, []);

  const handleResendOtp = useCallback(async () => {
    const mobile = props?.user?.phone_number || localStorage.getItem("phone_number");
    setOtp("");
    startOtpTimer();

    try {
      await props.sentOtpForappyLoan({ phone_number: mobile }, token);
    } catch (err) {
      if (!handleAuthError(err)) {
        ToastMsg(err?.response?.data?.error, "error");
      }
    }
  }, [props, token, startOtpTimer]);

  const handleOtpVerify = useCallback(async () => {
    const currentState = {
      voucher,
      rewardPointValue,
      paymeCoins,
      reference_1_name: reference1Name,
      reference_2_name: reference2Name,
      reference_1_phone: reference1Phone,
      reference_2_phone: reference2Phone,
    };

    const loanData = buildLoanData(currentState, referencesRef.current);

    if (esignVerifiedRef.current !== "S") {
      try {
        const res = await props.eSignWebView(token, isInsurance);
        setTimeout(() => {
          window.open(res.data.url, "_blank");
        }, 100);
      } catch (err) {
        // Silent fail for eSign
      }
      return;
    }

    if (esignVerifiedRef.current === "S" && !someStateRef.current && someCheckStatusRef.current) {
      setLoader(true);

      notifyVisitorEvent({
        event_name: "Esign_Completed",
        event_body: { Platform: "m-site" },
      }).catch(() => {});

      try {
        const res = await props.applyForLoan(token, loanData);
        setSomeState(true);
        if (res.status === 200) {
          navigate("/assigning_nbfc");
        }
      } catch (err) {
        setLoader(false);
        setLoanState(true);
        if (!handleAuthError(err)) {
          ToastMsg(err?.response?.data?.error, "error");
        }
      }
    }
  }, [voucher, rewardPointValue, paymeCoins, reference1Name, reference2Name, reference1Phone, reference2Phone, isInsurance, props, token, navigate]);

  const handleShow = useCallback(() => {
    const errors = [];

    if (referencesRef.current) {
      errors.push(...validateReferences());
    }

    if (showInsurance && isInsurance === null) {
      errors.push("Please select whether you want to secure your loan");
    }

    if (errors.length > 0) {
      ToastMsg(errors[0], "error");
      return;
    }

    someCheckStatusRef.current = true;
    setSomeCheckStatus(true);
    handleOtpVerify();
  }, [showInsurance, isInsurance, validateReferences, handleOtpVerify]);

  useEffect(() => {
    handleOtpVerifyRef.current = handleOtpVerify;
  }, [handleOtpVerify]);

  
  return (
    <div id="dashboardbackground" className="main_div">
      <div className="toolbarRespo">
        <div className="headAlign d-flex shadowline headBank maxWidth100 sticky-header mb-20 mt-20">
          <img
            style={{ cursor: "pointer", marginLeft: 20 }}
            className="customimgfix mt-2"
            src={arrowleft}
            onClick={() => navigate(-1)}
            alt="back"
          />
          <h1
            className="boldheading"
            style={{
              paddingLeft: "27px",
              color: "#152745",
              fontWeight: "800",
              fontSize: "25px",
            }}
          >
            {HEADING_LOANDETAIL}
          </h1>
        </div>
      </div>

      <div
        className="container"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          minHeight: "calc(100vh - 100px)",
        }}
      >
        <div className="pb-4 loandetailsfix">
          <div className="wrapper-content loan_det containerLoanDetail">
            <div className="toggle card-height-small w-100 mx-auto bg-grey ticketHistborder pl-20 newMarginFix mb-20">
              <div className="h-100 d-flex flex-column justify-content-between">
                <div className="pt-0 pb-0">
                  <table className="loan_d_sc">
                    <tbody>
                      <tr>
                        <td className="loantypefix">Loan Type</td>
                        <td>
                          <strong className="wrapper_m font600">
                            {localStorage.getItem("loan_type")}
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td className="loantypefix">Loan Amount</td>
                        <td>
                          <strong className="wrapper_m font600">
                            {localStorage.getItem("loanAmount")}
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td className="loantypefix">
                          {localStorage.getItem("loan_type") !== "P"
                            ? "First EMI Date"
                            : "Repayment Date"}
                        </td>
                        <td>
                          <strong className="wrapper_m font600">
                            {moment(localStorage.getItem("repayDate")).format("DD-MM-YYYY")}
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td className="loantypefix">Reason for Loan</td>
                        <td>
                          <strong className="wrapper_m font600">
                            {localStorage.getItem("loanReason")?.charAt(0)?.toUpperCase() +
                              localStorage.getItem("loanReason")?.slice(1)}
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {references && (
              <div>
                <span className="main-head_h-references">References</span>
                <div className="toggle card-height-small w-100 mx-auto bg-grey">
                  <div className="h-100 d-flex flex-column justify-content-between">
                    <div className="pt-0 pb-0">
                      <form action="#" style={{ position: "relative" }}>
                        <p className="referencestext mt-20">Reference 1 Name</p>
                        <input
                          type="text"
                          placeholder="Add reference 1 Name"
                          name="reference1"
                          value={reference1Name}
                          onChange={(e) => handleNameChange(e.target.value, setReference1Name)}
                          onKeyDown={(e) => {
                            if (e.key === " " && (!reference1Name || reference1Name.length === 0 || reference1Name.endsWith(" "))) {
                              e.preventDefault();
                            }
                          }}
                          onBeforeInput={(e) => {
                            if (!/^[A-Za-z\s'-]$/.test(e.data)) e.preventDefault();
                          }}
                          onPaste={(e) => {
                            const pasted = (e.clipboardData || window.clipboardData).getData("text");
                            if (!/^[A-Za-z\s'-]*$/.test(pasted)) e.preventDefault();
                          }}
                          onBlur={() => setReference1Name(reference1Name.trim())}
                          maxLength={50}
                          className="inputStyle outlinegeneralls"
                          style={{ marginBottom: 15 }}
                        />

                        <p className="referencestext">Reference 1 Mobile No.</p>
                        <input
                          type="text"
                          placeholder="Add reference 1 Mobile number"
                          name="reference1phone"
                          value={reference1Phone}
                          onChange={(e) => handlePhoneChange(e.target.value, setReference1Phone)}
                          className="inputStyle outlinegeneralls"
                          maxLength={10}
                          style={{ marginBottom: 15 }}
                        />

                        <p className="referencestext">Reference 2 Name</p>
                        <input
                          type="text"
                          placeholder="Add reference 2 Name"
                          name="reference2"
                          value={reference2Name}
                          onChange={(e) => handleNameChange(e.target.value, setReference2Name)}
                          onKeyDown={(e) => {
                            if (e.key === " " && (!reference2Name || reference2Name.length === 0 || reference2Name.endsWith(" "))) {
                              e.preventDefault();
                            }
                          }}
                          onBeforeInput={(e) => {
                            if (!/^[A-Za-z\s'-]$/.test(e.data)) e.preventDefault();
                          }}
                          onPaste={(e) => {
                            const pasted = (e.clipboardData || window.clipboardData).getData("text");
                            if (!/^[A-Za-z\s'-]*$/.test(pasted)) e.preventDefault();
                          }}
                          onBlur={() => setReference2Name(reference2Name.trim())}
                          className="inputStyle outlinegeneralls"
                          maxLength={50}
                          style={{ marginBottom: 15 }}
                        />

                        <p className="referencestext">Reference 2 Mobile No.</p>
                        <input
                          type="text"
                          placeholder="Add reference 2 Mobile Number"
                          name="reference2phone"
                          value={reference2Phone}
                          onChange={(e) => handlePhoneChange(e.target.value, setReference2Phone)}
                          className="inputStyle outlinegeneralls"
                          maxLength={10}
                          style={{ marginBottom: 15 }}
                        />
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {showInsurance && (
              <div>
                <p className="referencestext2 mt-20">
                  Do you want to secure your Loan?{" "}
                  <span
                    onClick={() => (window.location.href = "/insurance-tc")}
                    style={{
                      color: "#FC6603",
                      fontSize: "16px",
                      fontWeight: "600",
                      cursor: "pointer",
                    }}
                  >
                    T&C's
                  </span>
                </p>
                <div className="flexOption">
                  <div className="radioOption">
                    <input
                      onClick={() => {
                        setConsent("yes");
                        setIsInsurance(true);
                      }}
                      checked={consent === "yes"}
                      type="radio"
                      className="radioIn"
                    />
                    <p className="radioText">Yes</p>
                  </div>
                  <div className="radioOption">
                    <input
                      onClick={() => {
                        setConsent("no");
                        setIsInsurance(false);
                      }}
                      checked={consent === "no"}
                      type="radio"
                      className="radioIn"
                    />
                    <p className="radioText">No</p>
                  </div>
                </div>
              </div>
            )}

            {references && (
              <div className="loandetaildisc">
                By proceeding, you authorize MMB to disburse the loan upon agreement completion.
              </div>
            )}
          </div>
        </div>

        <div className="button-wrapper sticky-button-container text-center">
          {!references && (
            <div className="containerLoanDetail mx-auto" style={{ marginBottom: 10 }}>
              By proceeding, you authorize MMB to disburse the loan upon agreement completion.
            </div>
          )}
          <button className="NbfcBtntext" onClick={handleShow}>
            Accept and Verify
          </button>
        </div>

        <Modal
          show={show}
          onShow={handleResendOtp}
          centered
          className="loan_mn alignbottom"
        >
          <Modal.Body>
            <div className="popup-div">
              <span className="heading-pop">Enter OTP</span>
              <Form>
                <Form.Field>
                  <div className="flex_centre" style={{ marginTop: 27 }}>
                    <OtpInput
                      containerStyle="otpCover borderNone"
                      value={otp}
                      onChange={setOtp}
                      numInputs={4}
                      inputType="number"
                      renderSeparator={<span></span>}
                      renderInput={(inputProps) => <input {...inputProps} />}
                    />
                  </div>
                </Form.Field>
                <Form.Field
                  style={{
                    paddingBottom: 10,
                    textAlign: "center",
                    margin: "auto",
                  }}
                >
                  <div
                    style={{
                      textAlign: "center",
                      width: 181,
                      height: 56,
                      margin: "auto",
                    }}
                  >
                    <p className="receiveOTP">Didn't receive OTP?</p>
                    {canResendOtp ? (
                      <a className="resendOtp" onClick={handleResendOtp}>
                        Resend
                      </a>
                    ) : (
                      <a className="resendOtp" style={{ color: "#979797" }}>
                        Re-send in {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
                      </a>
                    )}
                  </div>
                </Form.Field>
              </Form>
              {otp.length === 4 ? (
                <div className="button-wrapper text-center mt-30">
                  <button
                    className="NbfcBtntext"
                    onClick={handleOtpVerify}
                    style={{ marginBottom: "0px" }}
                  >
                    Confirm
                  </button>
                </div>
              ) : (
                <div className="button-wrapper">
                  <button className="NbfcBtntext opacity-50 mt-30">Confirm</button>
                </div>
              )}
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user,
  userDetail: state.userDetail,
});

export default connect(mapStateToProps, {
  getDocumentStatus,
  eSignWebView,
  getPromoList,
  rewardPoint,
  applyForLoan,
  sentOtpForappyLoan,
})(LoanDetails);
